import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { PatientValueGetterComponent } from '../../shared/patient-value-getter/patient-value-getter.component';
import { AlertIconComponent } from '../../shared/alert-icon/alert-icon.component';

@Component({
  selector: "app-static-list",
  templateUrl: "./static-list.component.html",
  styleUrls: ["./static-list.component.scss"],
})

export class StaticListComponent implements OnInit {
  static key = 101003;
  
  reqSubcription: Subscription[] = [];
  loader = true;

  @Input("item") item: any = {};
  @Input("pageKey") pageKey: any;

  @ViewChild("staticListDiv", { static: true }) staticListDiv!: ElementRef;
  
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  
  rowData = [];
  public gridApi!: GridApi;
  public gridColumnApi: any;
  // columnDefs: ColDef[] = [];
  public defaultExportParams = {};
  public defaultColDef: ColDef<any> = {
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true,
    headerClass: "my-header-class",
  };
  headerNames: any = [];
  rowStyle = { "border-bottom": "#f3f3f3 1px solid" };
  paginationPageSize = 8;
  rowHeight = 50;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loader = true;

    const observer = new ResizeObserver((entries: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(entries[0].contentRect.height);
      }, 0); // Defers execution to the next event loop cycle
    });
    observer.observe(this.staticListDiv?.nativeElement);

    this.loadApiData()
    this.loadConfiguration()
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.paginationSetPageSize(this.paginationPageSize);
  }

  loadApiData() {
    
    this.apiService.getDoc('prioritized_patient_cases').subscribe((res: any) => {
      this.rowData = res ? res : [];
      this.loader = false;
    })
  }

  loadConfiguration() {
    this.columnDefs = this.columnDefs.map((m: any) => {
      let colDef: any = {};

      if (m.config.action || m.config.navigation) {
        colDef["cellRendererFramework"] = PatientValueGetterComponent;
        colDef["cellRendererParams"] = (params: any) => {
          let selectedData:any = [];
          if(m.field=="workflow_stage") {
            selectedData = [
              {
                  "col_value": "Benefit investigation",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#ffcd4a"
              },
              {
                  "col_value": "Shipment coordination",
                  "icon": "status",
                  "isSelect": true,
                  "color": "#fe5454"
              },
              {
                  "col_value": "Financial assistance",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#ff3da6"
              },
              {
                  "col_value": "PA Appeal",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#3ac97c"
              },
              {
                "col_value": "Intake",
                "isSelect": true,
                "icon": "status",
                "color": "#8a05f3"
              }
            ]
          } else if(m.field=="pa_appeal_status") {
            selectedData = [
              {
                  "col_value": "PA awaiting submission to provider",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#e468c1"
              },
              {
                  "col_value": "PA submitted to provider",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#0833cc"
              },
              {
                  "col_value": "PA submitted to payer",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#25d3eb"
              },
              {
                  "col_value": "Appeal awaiting submission to provider",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#bcd03f"
              },
              {
                  "col_value": "Appeal submitted to provider",
                  "isSelect": true,
                  "color": "#bcd03f",
                  "icon": "status"
              },
              {
                  "col_value": "Appeal submitted to payer",
                  "isSelect": true,
                  "icon": "status",
                  "color": "#fe5454"
              }
            ]
          } else if(m.field=="resolution_status") {
            selectedData = [{
              "col_value": "Yes, intervention resolved closed",
              "isSelect": true,
              "icon": "status",
              "color": "#7458e7"
          },
          {
              "col_value": "No, additional follow-up will be needed",
              "isSelect": true,
              "icon": "status",
              "color": "#7458e7"
          }]
          } else if(m.field=="intervention_outcome") {
            selectedData = [{
              "col_value": "Obtained missing information",
              "isSelect": true,
              "icon": "status",
              "color": "#e468c1"
            },
            {
                "col_value": "Issue resolved",
                "isSelect": true,
                "icon": "status",
                "color": "#4832a1"
            },
            {
                "col_value": "Fulfillment in process",
                "isSelect": true,
                "icon": "status",
                "color": "#8ccde9"
            },
            {
                "col_value": "Hub coordination",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx triage",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx Cancelled Discontinued",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel PA/Appeal not pursued by prescriber",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel PA Appeal denied by payer",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel pt request",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel MD request",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel alternative therapy",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Rx cancel alternative therapy",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Shipped",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            }]
          } else if(m.field=="intervention_action") {
            selectedData = [
              {
                "col_value": "Internal follow-up, CRM review",
                "isSelect": true,
                "icon": "status",
                "color": "#ffc164"
            },
            {
                "col_value": "External follow-up with Provider",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "External follow-up with Payer",
                "isSelect": true,
                "icon": "status",
                "color": "#e468c1"
            },
            {
                "col_value": "External follow-up with Manufacturer Hub",
                "isSelect": true,
                "icon": "status",
                "color": "#4832a1"
            },
            {
                "col_value": "Internal follow-up, Order creation",
                "isSelect": true,
                "icon": "status",
                "color": "#8ccde9"
            },
            {
                "col_value": "Internal follow-up, Operations coordination",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            }
            ]
          } else {
            selectedData = [
              {
                "col_value": "Eligibility review",
                "isSelect": true,
                "icon": "status",
                "color": "#9c41c7"
            },
            {
                "col_value": "Status inquiry",
                "isSelect": true,
                "icon": "status",
                "color": "#b04747"
            },
            {
                "col_value": "Recapture",
                "isSelect": true,
                "icon": "status",
                "color": "#81b660"
            },
            {
                "col_value": "Eligibility review",
                "isSelect": true,
                "icon": "status",
                "color": "#c45b0f"
            },
            {
                "col_value": "PA Appeal",
                "isSelect": true,
                "icon": "status",
                "color": "#c75fd0"
            },
            {
                "col_value": "Copay challenges",
                "isSelect": true,
                "icon": "status",
                "color": "#ffc164"
            },
            {
                "col_value": "Missing information",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            },
            {
                "col_value": "Pending HCP",
                "isSelect": true,
                "icon": "status",
                "color": "#e468c1"
            },
            {
                "col_value": "Pending PT",
                "isSelect": true,
                "icon": "status",
                "color": "#4832a1"
            },
            {
                "col_value": "Inventory analysis",
                "isSelect": true,
                "icon": "status",
                "color": "#8ccde9"
            },
            {
                "col_value": "Other",
                "isSelect": true,
                "icon": "status",
                "color": "#7458e7"
            }
            ]
          }

          let selectedStyles:any = {
            icon: m.config.actionIcon,
            color: "#1363df",
            position: "Right",
            staticPopup: true,
            extraText: {
              prefix: "",
              suffix: "",
            },
            iconsClickEvent: {},
            field:m.field,
            obj:m,
            staticStatus : [...selectedData]
          };

          if(!params.value) {
            return ""
          }
          
          return (
            this.cellRendererValueGetter(
              selectedData,
              params.data[m.field],
              params.value,
              selectedStyles
            ) || "" + params.value
          );
        };
      }

      if(m.config.alert) {
        colDef["cellRendererFramework"] = AlertIconComponent;
        colDef["cellRendererParams"] = (params: any) => {
          return {
            alertIcons: [
              {
                  "col_value": "Status Changes",
                  "isSelect": true,
                  "col_Config": [
                      {
                          "col_name": "Patient ID"
                      },
                      {
                          "col_name": "Source"
                      },
                      {
                          "col_name": "Prescriber Name"
                      },
                      {
                          "col_name": "Location"
                      },
                      {
                          "col_name": "FRM"
                      },
                      {
                          "col_name": "Shipment Date"
                      },
                      {
                          "col_name": "First Status Date"
                      },
                      {
                          "col_name": "Expected Next Fill Date"
                      }
                  ],
                  "icon": "status_change",
                  "color": "#ff9a3d"
              },
              {
                  "col_value": "New Patient",
                  "isSelect": true,
                  "col_Config": [
                      {
                          "col_name": "Patient ID",
                          "arrayIndex": 2,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Source",
                          "arrayIndex": 1,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Prescriber Name",
                          "arrayIndex": 3,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Location",
                          "arrayIndex": 4,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "FRM",
                          "arrayIndex": 5,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Shipment Date",
                          "arrayIndex": 6
                      },
                      {
                          "col_name": "First Status Date",
                          "arrayIndex": 7,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Expected Next Fill Date",
                          "arrayIndex": 8
                      }
                  ],
                  "icon": "new_patient",
                  "color": "#e34071"
              },
              {
                  "col_value": "New Prescriber",
                  "isSelect": true,
                  "col_Config": [
                      {
                          "col_name": "Patient ID",
                          "arrayIndex": 1,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Source",
                          "arrayIndex": 2,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Prescriber Name",
                          "arrayIndex": 3,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Location",
                          "arrayIndex": 4,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "FRM",
                          "arrayIndex": 5,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Shipment Date",
                          "arrayIndex": 6
                      },
                      {
                          "col_name": "First Status Date",
                          "arrayIndex": 7
                      },
                      {
                          "col_name": "Expected Next Fill Date",
                          "arrayIndex": 8
                      }
                  ],
                  "icon": "new_prescriber",
                  "color": "#3ac97c"
              },
              {
                  "col_value": "Refill Too Soon",
                  "isSelect": true,
                  "col_Config": [
                      {
                          "col_name": "Patient ID",
                          "arrayIndex": 6,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Source",
                          "arrayIndex": 2
                      },
                      {
                          "col_name": "Prescriber Name",
                          "arrayIndex": 3
                      },
                      {
                          "col_name": "Location",
                          "arrayIndex": 4
                      },
                      {
                          "col_name": "FRM",
                          "arrayIndex": 5
                      },
                      {
                          "col_name": "Shipment Date",
                          "arrayIndex": 1,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "First Status Date",
                          "arrayIndex": 7
                      },
                      {
                          "col_name": "Expected Next Fill Date",
                          "arrayIndex": 8
                      }
                  ],
                  "icon": "refill_alerts",
                  "color": "#1363df"
              },
              {
                  "col_value": "Shipment Delayed",
                  "isSelect": true,
                  "col_Config": [
                      {
                          "col_name": "Patient ID",
                          "arrayIndex": 8,
                          "isConfigSelect": true
                      },
                      {
                          "col_name": "Source",
                          "arrayIndex": 2,
                          "isConfigSelect": false
                      },
                      {
                          "col_name": "Prescriber Name",
                          "arrayIndex": 3,
                          "isConfigSelect": false
                      },
                      {
                          "col_name": "Location",
                          "arrayIndex": 4,
                          "isConfigSelect": false
                      },
                      {
                          "col_name": "FRM",
                          "arrayIndex": 5
                      },
                      {
                          "col_name": "Shipment Date",
                          "arrayIndex": 6
                      },
                      {
                          "col_name": "First Status Date",
                          "arrayIndex": 7
                      },
                      {
                          "col_name": "Expected Next Fill Date",
                          "arrayIndex": 1,
                          "isConfigSelect": true
                      }
                  ],
                  "icon": "delayed_alert",
                  "color": "#d11044"
              }
          ],
            dataFromPatient: params,
          };
        };
      }

      if (m.field === 'comments') {
        colDef["valueFormatter"] = (params: any) => {
          if (params.value && params.value.length > 50) {
            return params.value.substring(0, 47) + '...';
          }
          return params.value;
        };
        colDef["tooltipValueGetter"] = (params: any) => params.value;
      }
      
      return { ...m, ...colDef };
    });
  }

  columnDefs: ColDef[] | any = [
    {
      headerName: "Patient's ID",
      field: "src_curr_sp_patient_id",
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 150,
      cellStyle: {color: "#1363df"},
      config: {
        action:false,
        navigation:true,
        actionIcon: "greater_than",
        alert:false
      }
    },
    {
      headerName: "Patient's Risk Score",
      field: 'pak_risk_score',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 150,
      config: {
        action:false,
        navigation:false,
        actionIcon: "",
        alert:false
      }
    },
    {
      headerName: "Indication",
      field: 'indication',
      hide: false,
      cellClass: "cell-wrap-text",
      cellStyle: {textAlign: "center"},
      autoHeight: true,
      minWidth: 150,
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:false
      }
    },
    {
      headerName: "Alerts",
      field: 'alert',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:true
      }
    },
    {
      headerName: "Workflow Stage",
      field: 'workflow_stage',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "PA / Appeal Status",
      field: 'pa_appeal_status',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "Issue Type",
      field: 'issue_type',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "Intervention Action",
      field: 'intervention_action',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "Intervention Date",
      field: 'intervention_date',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 150,
      cellStyle: {textAlign: "center"},
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:false
      }
    },
    {
      headerName: "Intervention Outcome",
      field: 'intervention_outcome',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "Resolution Status",
      field: 'resolution_status',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 220,
      config: {
        action: true,
        navigation: false,
        actionIcon: "plus",
        alert:false
      }
    },
    {
      headerName: "Follow-up Date",
      field: 'follow_up_date',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 150,
      cellStyle: {textAlign: "center"},
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:false
      }
    },
    {
      headerName: "Comments",
      field: 'comments',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 200,
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:false
      }
    },
    {
      headerName: "Transaction ID",
      field: 'transaction_id',
      hide: false,
      cellClass: "cell-wrap-text",
      autoHeight: true,
      minWidth: 150,
      cellStyle: {textAlign: "center"},
      config: {
        action: false,
        navigation: false,
        actionIcon: "",
        alert:false
      }
    },
  ]

  cellRendererValueGetter(
    rangeValue: any,
    param: any,
    value: any,
    selectedStyles: any
  ) {

    if (!selectedStyles) {
      if (!rangeValue) return null;
    }
    
    if (rangeValue && !selectedStyles) {
      for (let idx in rangeValue) {
        let r = rangeValue[idx];
        if (r.col_value == param) {
          let icon: any = r.icon;
          let color: any = r.color;
          return { icon, value, color, selectedStyles };
        }
      }
    } else if (rangeValue && selectedStyles) {
      let fnd: any = rangeValue.find((res: any) => res.col_value == param)
      if (fnd) {
        for (let idx in rangeValue) {
          let r = rangeValue[idx];
          let icon = '';
          let color = '';

          if (r.col_value.toLowerCase() == param.toLowerCase()) {
            icon = r.icon;
            color = r.color;
            return { icon, value, color, selectedStyles };
          }
        }
      } else {
        return { selectedStyles };
      }
    } else if (selectedStyles) {
      return { value, selectedStyles };
    }
  }
}